<template>
  <figure class="c-icon c-icon--arrow-square" :style="style">

    <svg>
      <use xlink:href="#arrow-square"></use>
    </svg>

  </figure>
</template>

<script>

export default {
  name: 'IconArrowSquare',

  props: ['direction'],

  computed: {
    style () {
      const direction = this.direction
      const style = {}

      if (!direction) {
        return style
      }

      if (direction === 'left') {
        style.transform = 'rotate(90deg)'
      }

      if (direction === 'up') {
        style.transform = 'rotate(180deg)'
      }

      if (direction === 'right') {
        style.transform = 'rotate(270deg)'
      }

      return style
    }
  }
}
</script>
